import { RefreshCw } from "lucide-react";

export function formatSyncedAgo(when) {
  if (!when) return "";
  const t = when instanceof Date ? when : new Date(when);
  const secs = Math.max(1, Math.floor((Date.now() - t.getTime()) / 1000));
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
}

/**
 * Small "Synced Xm ago" chip used across live-data surfaces (cleaner widget,
 * Inbox stats, digest last-run). Pass `busy` while a fetch is in flight so
 * the refresh glyph spins. Pass `onRefresh` to turn it into a click-to-refresh
 * button (falls back to a static pill when omitted).
 */
export function SyncedChip({ syncedAt, busy = false, testid, className = "", onRefresh }) {
  if (!syncedAt) return null;
  const label = (
    <>
      <RefreshCw className={"w-2.5 h-2.5 " + (busy ? "animate-spin" : "")} />
      Synced {formatSyncedAgo(syncedAt)}
    </>
  );
  const base =
    "inline-flex items-center gap-1 px-2 h-5 rounded-full text-[10px] normal-case tracking-normal border transition ";
  if (onRefresh) {
    return (
      <button
        type="button"
        data-testid={testid || "synced-chip"}
        onClick={onRefresh}
        disabled={busy}
        title={`Last synced ${new Date(syncedAt).toLocaleString()} — click to refresh`}
        className={base + "bg-slate-100 text-slate-600 border-slate-200 hover:bg-teal-50 hover:text-teal-700 hover:border-teal-200 disabled:opacity-60 " + className}
      >
        {label}
      </button>
    );
  }
  return (
    <span
      data-testid={testid || "synced-chip"}
      className={base + "bg-slate-100 text-slate-500 border-slate-200 " + className}
      title={new Date(syncedAt).toLocaleString()}
    >
      {label}
    </span>
  );
}
